import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLogin: false, userInfo: null, currentActivity: null, screenWidth: 0, screenHeight: 0, routerInfo: {
            name: "登录", path: "/", routeMenu: []
        },
    }, mutations: {
        setIsLogin(state, isLogin) {
            state.isLogin = isLogin
        }, setCurrentActivity(state, currentActivity) {
            state.currentActivity = currentActivity
        }, setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        }, setScreenWidth(state, screenWidth) {
            state.screenWidth = screenWidth
        }, setScreenHeight(state, screenHeight) {
            state.screenHeight = screenHeight
        }, setRouteInfo(state, routeInfo) {
            state.routeInfo = routeInfo
        },
    }, actions: {
        setIsLogin(context, isLogin) {
            context.commit('setIsLogin', isLogin)
        }, setCurrentActivity(context, currentActivity) {
            context.commit('setCurrentActivity', currentActivity)
        }, setRouteInfo(context, routeInfo) {
            context.commit('setRouteInfo', routeInfo)
        }, setUserInfo(context, userInfo) {
            context.commit('setUserInfo', userInfo)
        }, setScreenWidth(context, screenWidth) {
            context.commit('setScreenWidth', screenWidth)
        }, setScreenHeight(context, screenHeight) {
            context.commit('setScreenHeight', screenHeight)
        }
    }, modules: {}
})
